module.exports = __webpack_public_path__ + "static/fullLogoBlack-4457eb5b1b3efd50ec8d34eaae2b0600.svg";